<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="次卡种类">
                  <!-- <el-input style='width: 186px' v-model="queryForm.cardId"></el-input> -->
                <el-select
                  size="small"
                  style="width: 186px"
                  v-model="queryForm.cardId"
                  clearable
                >
                  <el-option
                    v-for="item in cardIds"
                    :key="item.id"
                    :label="item.cardName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelect
                    title='选择用户'
                    labelName='userName'
                    labelValue='id'
                    :value='queryForm.userId'
                    :limit='1'
                    style='width: 186px'
                    size='small'
                    placeholder='请选择用户'
                    @getValue='getValue1'
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl='/mpp/user/findList'
                    entityBeanName='mppUser'
                    queryEntityUrl='/mpp/user/get'
                >
                </GridSelect>
              </el-form-item>
              <el-form-item label="剩余次数">
                  <el-input style='width: 186px' v-model="queryForm.leftTimes"></el-input>
              </el-form-item>
              <!-- <el-form-item label="过期时间">
                  <el-input  v-model="queryForm.expiredTime"></el-input>
              </el-form-item> -->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopTimescardBuyList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopTimescardBuy"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopTimescardBuy(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopTimescardBuy(null)"
        >删除</el-button>
        <el-button
          type="primary"
          size="small"
          @click="showCardPresent"
        >次卡种类</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
              :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopTimescardBuyList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopTimescardBuyList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopTimescardBuyList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardId"
        label="次卡种类"
        min-width="180"
      >
        <template slot-scope='scope'>
          <div v-if="scope.row.card">
            <div style='text-align: left'>名称：{{ scope.row.card.cardName ? scope.row.card.cardName : '--' }}</div>
            <div style='text-align: left'>总次数：{{ scope.row.card.cardTimes ? scope.row.card.cardTimes : '--' }}</div>
            <!-- <div style='text-align: left'>可使用次数：{{ scope.row.card.limitTimes ? scope.row.card.limitTimes : '--' }}</div> -->
            <!-- <div style='text-align: left'>姓名：{{ scope.row.user.userRealname ? scope.row.user.userRealname : '--' }}</div> -->
          </div>
          <div v-else>--</div>
          <!-- <div v-if="scope.row.card" style='text-align: left'>名称：{{scope.row.card.cardName}}</div>
          <div v-else>--</div> -->
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        min-width="180"
      >
        <template slot-scope='scope'>
          <div v-if="scope.row.user">
            <div style='text-align: left'>账号：{{ scope.row.user.userName ? scope.row.user.userName : '--' }}</div>
            <div style='text-align: left'>手机：{{ scope.row.user.userMobile ? scope.row.user.userMobile : '--' }}</div>
            <div style='text-align: left'>昵称：{{ scope.row.user.userNickname ? scope.row.user.userNickname : '--' }}</div>
            <div style='text-align: left'>姓名：{{ scope.row.user.userRealname ? scope.row.user.userRealname : '--' }}</div>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="leftTimes"
        label="剩余次数"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="expiredTime"
        label="过期时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="showRedPacketRecord(scop.row.cardId)">
                <Icon size="16">
                    <Eye24Regular />
                </Icon>
                <span class="operation-label">使用详情</span>
            </div>
            <div @click="checkShopTimescardBuy(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopTimescardBuy(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopTimescardBuy(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopTimescardBuyStates[shopTimescardBuyState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopTimescardBuy"
          ref="shopTimescardBuyForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="次卡种类"
            prop="cardId"
          >
            <!-- <el-input
              size="small"
              style='width: 186px'
              v-model="shopTimescardBuy.cardId"
              :disabled="shopTimescardBuyState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px"
              v-model="shopTimescardBuy.cardId"
              :disabled="shopTimescardBuyState == 'check'"
              clearable
            >
              <el-option
                v-for="item in cardIds"
                :key="item.id"
                :label="item.cardName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="shopTimescardBuy.userId"
              :disabled="shopTimescardBuyState == 'check'"
            ></el-input> -->
            <GridSelect
                title='选择用户'
                labelName='userName'
                labelValue='id'
                :disabled="shopTimescardBuyState == 'check'"
                :value='shopTimescardBuy.userId'
                :limit='1'
                style='width: 186px'
                size='small'
                placeholder='请选择用户'
                @getValue='getValue'
                :columns="USER_code"
                :searchs="USER_search"
                dataListUrl='/mpp/user/findList'
                entityBeanName='mppUser'
                queryEntityUrl='/mpp/user/get'
            >
            </GridSelect>
          </el-form-item>
          <el-form-item
            label="剩余次数"
            prop="leftTimes"
          >
            <el-input
              size="small"
              style='width: 186px'
              v-model="shopTimescardBuy.leftTimes"
              :disabled="shopTimescardBuyState == 'check'"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="过期时间"
            prop="expiredTime"
          >
            <el-input
              size="small"
              v-model="shopTimescardBuy.expiredTime"
              :disabled="shopTimescardBuyState == 'check'"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopTimescardBuyState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
    <el-drawer
        title="次卡种类"
        :visible.sync="cardPresentStatus"
        direction="rtl"
        size="70%"
        :before-close="cardPresentClose">
        <ShopTimescardType></ShopTimescardType>
    </el-drawer>
    <el-drawer
        title="使用详情"
        :visible.sync="cardShoppingStatus"
        direction="rtl"
        size="70%"
        :before-close="cardShoppingClose">
        <ShopTimescardUse :id="id" ref="shopUse"></ShopTimescardUse>
    </el-drawer>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ShopTimescardType from '@/components/shop/ShopTimescardType.vue';
import ShopTimescardUse from '@/components/shop/ShopTimescardUse.vue';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ShopTimescardType,
        ShopTimescardUse,
        GridSelect
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopTimescardBuyList();
                    this.getShopTimescardBuyList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopTimescardBuyList();
                    this.getShopTimescardBuyList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     cardId: '', //次卡种类
                     userId: '', //用户
                     leftTimes: '', //剩余次数
                     expiredTime: '', //过期时间
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopTimescardBuyState: 'add',
                shopTimescardBuyStates: {
                    add: '新建次卡购买记录',
                    check: '查看次卡购买记录',
                    edit: '修改次卡购买记录'
                },
                id: '',
                multipleSelection: [],
                shopTimescardBuyList: [],
                shopTimescardBuy: {
                    id: '', //ID
                    cardId: '', //次卡种类
                    userId: '', //用户
                    leftTimes: '', //剩余次数
                    expiredTime: '', //过期时间
                    createTime: '', //创建时间
                },
                btnLoading: false,
                cardPresentStatus: false,
                cardShoppingStatus: false,
                rules: {
                    cardId: [{ required: true, message: '次卡种类不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    leftTimes: [{ required: true, message: '剩余次数不能为空', trigger: 'blur' }],
                    expiredTime: [{ required: true, message: '过期时间不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                },
                cardIds:[],
            };
        },
        created() {
            this.getShopTimescardBuyList();
            this.getcardIds();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getcardIds(){
              get(`/shop/timescardtype/findAll`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                  if (res.success) {
                      this.cardIds = res.list;
                  }
              });
            },
            getValue(val){
              this.shopTimescardBuy.userId = val;
            },
            getValue1(val){
              this.queryForm.userId = val;
            },
            showRedPacketRecord(id) {
                this.id = id
                this.cardShoppingStatus = true;
                this.$nextTick(()=>{
                    this.$refs.shopUse.getShopTimescardUseList();
                })
            },
            showCardPresent(){
              this.cardPresentStatus = true
            },
            // showCardShopping(){
            //     this.cardShoppingStatus = true
            // },
            cardPresentClose(){
                this.cardPresentStatus = false
            },
            cardShoppingClose(){
                this.cardShoppingStatus = false
            },
            resetShopTimescardBuyList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopTimescardBuyList = [];
            },
            resetDialog() {
                this.shopTimescardBuyState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      cardId: '', //次卡种类
                      userId: '', //用户
                      leftTimes: '', //剩余次数
                      expiredTime: '', //过期时间
                };
                this.getShopTimescardBuyList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopTimescardBuy = {
                      id: '', //ID
                      cardId: '', //次卡种类
                      userId: '', //用户
                      leftTimes: '', //剩余次数
                      expiredTime: '', //过期时间
                      createTime: '', //创建时间
                };
            },
            submitForm() {
                if (this.shopTimescardBuyState == 'add') {
                    this.$refs.shopTimescardBuyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/timescardbuy/add`,{ ...this.shopTimescardBuy }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopTimescardBuyList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopTimescardBuyState == 'edit') {
                    this.$refs.shopTimescardBuyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopTimescardBuy.card
                            delete this.shopTimescardBuy.user
                            post(`/shop/timescardbuy/edit`,{ ...this.shopTimescardBuy }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopTimescardBuyList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopTimescardBuy() {
                this.showDialog = true;
                this.shopTimescardBuyState = 'add';
            },
            checkShopTimescardBuy(shopTimescardBuyId) {
                console.log(shopTimescardBuyId);
                this.currentShopTimescardBuyId = shopTimescardBuyId;

                this.getShopTimescardBuyById();
                this.showDialog = true;
                this.shopTimescardBuyState = 'check';
            },
            editShopTimescardBuy(shopTimescardBuyId) {
                console.log('shopTimescardBuy', shopTimescardBuyId);
                if (shopTimescardBuyId) {
                    this.currentShopTimescardBuyId = shopTimescardBuyId;
                    this.getShopTimescardBuyById();
                } else {
                    this.shopTimescardBuy = { ...this.shopTimescardBuy, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopTimescardBuyState = 'edit';
            },
            deleteShopTimescardBuy(shopTimescardBuyId) {
                let ids = '';
                if (shopTimescardBuyId) {
                    ids = shopTimescardBuyId;
                } else {
                    ids = this.multipleSelection.map((shopTimescardBuy) => shopTimescardBuy.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/timescardbuy/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopTimescardBuyList();
                                this.getShopTimescardBuyList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopTimescardBuyList() {
                this.resetShopTimescardBuyList();
                this.getShopTimescardBuyList();
            },
            getShopTimescardBuyList(query = {}) {
                this.loading = true;
                get(`/shop/timescardbuy/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopTimescardBuyList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopTimescardBuyById() {
                get(`/shop/timescardbuy/get`,{ id: this.currentShopTimescardBuyId }).then((res) =>{
                    if(res.success){
                      this.shopTimescardBuy = { ...this.shopTimescardBuy, ...res.shopTimescardBuy };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopTimescardBuyList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/timescardbuy/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/timescardbuy/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/timescardbuy/importData`,formData);
              this.refreshShopTimescardBuyList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopTimescardBuyList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopTimescardBuyList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>